/* eslint-disable no-await-in-loop */
import React from 'react';
import {
  ProgressIndicator,
  PrimaryButton,
  Stack,
  Text,
  IRefObject,
  ISlider,
  Slider,
} from '@fluentui/react';
import { createUseStyles } from 'react-jss';

import { topics } from './const';
import { useMockUser } from './mockUser';
import { useBot } from './bot';
import { useEvaluator } from './evaluator';

const useStyles = createUseStyles({
  root: {
    '& .chatProgress': {
      marginTop: '30px',
    },
    '& .chatResult': {
      marginTop: '10px',
      fontSize: '14px',
      maxHeight: '200px',
      overflow: 'auto',
    },
    '& .evaluateProgress': {
      marginTop: '10px',
    },
    '& .evaluateResult': {
      marginTop: '10px',
      fontSize: '14px',
      maxHeight: '100px',
      overflow: 'auto',
    },
    '& .buttonGroup': {
      marginTop: '30px',
      marginBottom: '-30px',
      '& .evaluateButton': {
        marginLeft: '10px',
      },
    },
  },
});

const DefaultRoundNumber = 5;

export const PromptTest: React.FunctionComponent = () => {
  const classes = useStyles();
  const {
    sendMessage: sendMockUserMessage,
    clearHistory: clearMockUserHistory,
    setTopic,
  } = useMockUser();
  const { sendMessage: sendBotMessage, clearHistory: clearBotHistory } = useBot();
  const { sendMessage: sendEvaluatorMessage, clearHistory: clearEvaluatorHistory } = useEvaluator();

  const [percentChat, setPercentChat] = React.useState(0);
  const [percentEvaluate, setPercentEvaluate] = React.useState(0);
  const [messageForEvaluator, setMessageForEvaluator] = React.useState([] as string[]);
  const [rateResult, setRateResult] = React.useState('');

  const roundNumberSliderRef = React.useRef<ISlider>();

  let userMessage: string = topics[0];
  let botMessage: string;
  const totalMessages: string[] = [];

  const clearHistory = () => {
    clearMockUserHistory();
    clearBotHistory();
    clearEvaluatorHistory();
  };

  const logMessage = (message: string, sender: string) => {
    if (sender === 'user') {
      const currentMessage = `user: ${message}`;
      totalMessages.push(currentMessage);
    } else {
      const currentMessage = `bot: ${message}`;
      totalMessages.push(currentMessage);
    }
  };

  const chat = async () => {
    clearHistory();
    await setTopic(userMessage);
    logMessage(userMessage, 'user');
    botMessage = await sendBotMessage(userMessage);
    logMessage(botMessage, 'bot');
    const round = roundNumberSliderRef.current?.value as number || DefaultRoundNumber;
    for (let i = 1; i < round; i++) {
      userMessage = await sendMockUserMessage(botMessage);
      logMessage(userMessage, 'user');
      botMessage = await sendBotMessage(userMessage);
      logMessage(botMessage, 'bot');
      setPercentChat((i + 1) / round);
    }
    setMessageForEvaluator(totalMessages);
  };

  const evaluate = async () => {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const chat = messageForEvaluator.join('<br>');
    const rate = await sendEvaluatorMessage(chat);
    setPercentEvaluate(1);
    setRateResult(rate);
  };

  return (
    <div className={classes.root}>
      <Slider
        label="Chat Round Number"
        componentRef={roundNumberSliderRef as IRefObject<ISlider>}
        defaultValue={5}
        min={1}
        max={20}
        step={1}
      />
      <ProgressIndicator className="chatProgress" label="chatting progress" percentComplete={percentChat} />
      <div className="chatResult">
        Chat result:
        {messageForEvaluator.map((message, index) => (
          index % 2 ? <Text block>{message}</Text> : <Text block style={{ color: 'blue' }}>{message}</Text>
        ))}
      </div>
      <ProgressIndicator className="evaluateProgress" label="evaluating progress" percentComplete={percentEvaluate} />
      <div className="evaluateResult">
        {`Evaluate result: ${rateResult}`}
      </div>
      <Stack horizontal className="buttonGroup">
        <PrimaryButton onClick={chat}>Start chatting</PrimaryButton>
        <PrimaryButton onClick={evaluate} className="evaluateButton">Start evaluating</PrimaryButton>
      </Stack>
    </div>
  );
};
